<template>
  <div class="contenttit">
    <div class="contenttitl"><slot></slot></div>
    <div class="contenttitr">
      <span>Details</span><img src="@/assets/m/home/right.png" />
    </div>
  </div>
</template>

<script>
const echarts = require("echarts");
export default {
  data() {
    return {
      value: "",
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.contenttit {
  display: flex;
  justify-content: space-between;
  padding-top: 24px;
  .contenttitl {
    height: 42px;
    font-size: 30px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #898b8d;
    line-height: 42px;
    margin-left: 24px;
  }
  .contenttitr {
    width: 150px;
    height: 44px;
    line-height: 44px;
    background: #000000;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    font-size: 24px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    margin-right: 24px;
    span {
      margin-left: 24px;
      margin-top: 8px;
    }
    img {
      width: 40px;
      height: 40px;
      margin-left: 6px;
      margin-top: 2px;
    }
  }
}
</style>
